import IAttachmentLink = ZoningAPI.IAttachmentLink;
import { ClonableItem } from './clonable-item';
import { getPrettyAttachmentType } from '../enums/attachment-type-enum';

export class AttachmentLink extends ClonableItem<IAttachmentLink> implements IAttachmentLink {
    Id: number;
    ParentId: number;
    ParentTypeId: number;
    Link: string;
    AttachmentTypeId: number;
    FileName?: string;
    URL?: string;
    createdAt: Date;
    updatedAt: Date;

    constructor(value?: IAttachmentLink) {
        super(value);
    }

    public get attachmentTypeStr() {
        return getPrettyAttachmentType(this.AttachmentTypeId);
    }
}

export function AttachmentLinkFactory(data: IAttachmentLink) {
    return new AttachmentLink(data);
}
